import React, { useState, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';

const formatLabel = (segment = "") => {
  return segment
    .replace(/-/g, " ")
    .split(" ")
    .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : ""))
    .join(" ");
};

const BodyHeader = (props) => {
  const { title } = props;

  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    const pathSegments = location.pathname
      .split("/")
      .filter((segment) => segment !== "");

    const isListPage =
      pathSegments.length > 0 &&
      pathSegments[pathSegments.length - 1].toLowerCase() === "list";

    const breadcrumbsArray = pathSegments.map((segment, index) => {
      let path = `/${pathSegments.slice(0, index + 1).join("/")}`;
      if (isListPage && index <= pathSegments.length - 2) {
        path = `${path}/list`;
      }
      return {
        path,
        label: formatLabel(segment),
      };
    });
    setBreadcrumbs(breadcrumbsArray);
  }, [location]);

  return (
    <div className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1 className="m-0">{title}</h1>
          </div>
          <div className="col-sm-6">
        

            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Home</Link>
              </li>
              {breadcrumbs.map((breadcrumb, index) => {
                const isLast = index === breadcrumbs.length - 1;
                return (
                  <li
                    className={`breadcrumb-item${isLast ? " active" : ""}`}
                    key={`${index}`}
                  >
                    {!isLast ? (
                      <Link to={breadcrumb.path}>{breadcrumb.label}</Link>
                    ) : (
                      <span>{breadcrumb.label}</span>
                    )}
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BodyHeader;
